<ndt-user-detail-view
   [user]="user$ | async"
   [privileges]="privileges$ | async"
   [userPrivileges]="userPrivileges$ | async"
   [accountId]="accountId$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   [extensions]="extensions$ | async"
   [extensionGroups]="extensionGroups$ | async"
   [isOnSystemPage]="isOnSystemPage$ | async"
   [isAdminUser]="isAdminUser$ | async"
   [isSystemUser]="isSystemUser$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (formSubmitted)="onFormSubmitted($event)"
   (deleteUser)="onDeleteUser($event)"
   (unlockUser)="onUnlockUser($event)"
   (resendVerificationEmail)="onResendVerificationEmail($event)"
></ndt-user-detail-view>
